import { ACTIONS } from '../../_config'
import { ActionExtended } from '../../_config/interfaces/interfaces';

export interface MenuToggleReducer {
  menuToggle: boolean;
}

const initialState: MenuToggleReducer = {
  menuToggle: true
};

const menuToggleReducer = (state = initialState, action: ActionExtended) => {
  switch (action.type) {
    case ACTIONS.MENU.TOGGLE:
      return {
        ...state,
        menuToggle: !state.menuToggle,
      };
    default:
      return state;
  }
};

export default menuToggleReducer;
